import {
  MutationAddCheckItemArgs,
  MutationDeleteCheckItemArgs,
  MutationUpdateCheckItemNameArgs,
  MutationUpdateCheckItemPosArgs,
  MutationUpdateCheckItemStateArgs,
} from '../../generated';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { token } from '@trello/session-cookie';

export const addCheckItem = async (
  obj: object,
  args: MutationAddCheckItemArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(
    `/1/cards/${args.cardId}/checklist/${args.checklistId}/checkItem`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: args.name,
        nameData: {
          emoji: {},
        },
        token,
      }),
    },
  );

  const checkItem = await response.json();

  checkItem.temporaryId = args.temporaryId;

  return prepareDataForApolloCache(checkItem, info);
};

export const deleteCheckItem = async (
  obj: object,
  args: MutationDeleteCheckItemArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(
    `/1/cards/${args.cardId}/checklist/${args.checklistId}/checkItem/${args.checkItemId}`,
    {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
      }),
    },
  );

  await response.json();

  return prepareDataForApolloCache({ success: true }, info);
};

export const updateCheckItemName = async (
  obj: object,
  args: MutationUpdateCheckItemNameArgs,
  context: object,
  info: QueryInfo,
) => {
  const params = new URLSearchParams();
  params.set('name', args.name);
  params.set('token', token || '');

  const response = await fetch(
    `/1/cards/${args.cardId}/checklist/${args.checklistId}/checkItem/${args.checkItemId}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: params,
    },
  );

  const checkItem = await response.json();

  return prepareDataForApolloCache(checkItem, info);
};

export const updateCheckItemPos = async (
  obj: object,
  args: MutationUpdateCheckItemPosArgs,
  context: object,
  info: QueryInfo,
) => {
  const params = new URLSearchParams();
  params.set('pos', `${args.pos}`);
  params.set('token', token || '');

  const response = await fetch(
    `/1/cards/${args.cardId}/checklist/${args.checklistId}/checkItem/${args.checkItemId}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: params,
    },
  );

  const checkItem = await response.json();

  return prepareDataForApolloCache(checkItem, info);
};

export const updateCheckItemState = async (
  obj: object,
  args: MutationUpdateCheckItemStateArgs,
  context: object,
  info: QueryInfo,
) => {
  const params = new URLSearchParams();
  params.set('state', args.state);
  params.set('token', token || '');

  const response = await fetch(
    `/1/cards/${args.cardId}/checklist/${args.checklistId}/checkItem/${args.checkItemId}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: params,
    },
  );

  const checkItem = await response.json();

  return prepareDataForApolloCache(checkItem, info);
};
